import React from 'react';
import PropTypes from 'prop-types';
import styles from './Table.module.scss';

const Table = ({ children, striped, hoverable, compact, className, ...rest }) => {
  const classNames = [
    styles.table,
    striped ? styles.striped : '',
    hoverable ? styles.hoverable : '',
    compact ? styles.compact : '',
    className || '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <table className={classNames} {...rest}>
      {children}
    </table>
  );
};

Table.propTypes = {
  children: PropTypes.node.isRequired,
  striped: PropTypes.bool,
  hoverable: PropTypes.bool,
  compact: PropTypes.bool,
  className: PropTypes.string,
};

Table.defaultProps = {
  striped: false,
  hoverable: false,
  compact: false,
  className: '',
};

export default Table;
